export class SettingsRoutingConstants {
    static AvailableSurvey123s = "availablesurvey123s";
    static Lookups = "lookups";
    static MapServices = "mapservices";
    static NonWorkingDays = "nonworkingdays";
    static AttachmentTypes = "attachmenttypes";
    static Recipients = "recipients";
    static Reports = "reports";
    static StepMetaData = "stepmetadata";
    static Tariffs = "tariffs";
    static Templates = "templates";
    static InvoiceTemplates = "invoicetemplates";
    static RecipientGroups = "recipientgroups";
    static Stamps = "stamps";
    static NotificationTemplates = "notificationtemplates";
    static ModuleRoles = "moduleroles";
    static AFLAPortalDocuments = "aflaportaldocuments";
    static AFLAPortalUpdateOwners = "aflaportalupdateowners";
    static SearchOptions = "searchoptions";
    static BackupRestore = "backupandrestore";
    static ArcGISItems = "arcgisitems";
    static ApplicationWorkflowUpgrade = "applicationworkflowupgrade";
    static AFLAPortalMessagesAndPages = "aflaportalmessagesandpages";
    static PvValuationRun = "pvprojectcycle";
    static PvValuationRoll = "pvvaluationroll";
    static PvAttributesAndParameters = "pvattributesandparameters";
    static LinkInspectionSurveys = "linkinspectionsurveys";
}
export class AttributesAndParametersRoutingConstants {
    static HOME_ROUTE = "home";
    static PARAMETERS_ROUTE = "parameters";
    static FACTOR_ADJUSTMENT_ROUTE = "factoradjustment";
    static STRUCTURE_TYPE_ROUTE = "structuretype";
    static VALUE_ADJUSTMENT_ROUTE = "valueadjustment";
    static RUN_SURVEY_ROUTE = "runsurvey";
    static AGRICULTURAL_ACTIVITY_ROUTE = "agriculturalactivity";
    static DEPRECIATION_FACTOR_ROUTE = "depreciationfactor";
}
